@if (loading) {
  <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
} @else {
  <ng-container>
    @if (energyTypeConsumptionsList?.length) {
      <nb-accordion multi class="custom-accordion mt-0" (toggle)="onAccordionToggle($event)">
        @if (energyTypeConsumptionsList?.length > 1) {
        <!-- ALL ENERGY TYPES CONSUMPTIONS -->
        <nb-accordion-item expanded>
          <nb-accordion-item-header>
            <span class="text">{{ "Total consumption of all energies" | translate }}</span>
          </nb-accordion-item-header>
          <nb-accordion-item-body>
            <table class="table with-data">
              <thead>
                <tr>
                  <th class="w-20 align-middle">{{ "Building" | translate }}</th>
                  <th class="align-middle">{{ "Year" | translate }}</th>
                  <th class="align-middle">{{ "Raw consumption" | translate }}</th>
                  <th class="align-middle">{{ "Corrected uses and climate" | translate }}</th>
                  <th class="align-middle">{{ "Corrected official" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (consumption of allConsumptionsList; track consumption.id) {
                <tr>
                  <td class="align-middle">
                    {{ consumption.perimeter.name }}
                    @if (consumption.area) { ({{ consumption.area | thousandsSeparator }} {{ "m²" | translate }}) }
                  </td>
                  <td class="align-middle">{{ consumption.year }}</td>
                  <td class="align-middle">
                    @if (consumption.consumption) {
                    {{ consumption.consumption | thousandsSeparator }} {{ "kWh" | translate }}
                    } @else { - }
                  </td>
                  <td class="align-middle">
                    @if (consumption.consumption_corrected_climate) {
                    {{ consumption.consumption_corrected_climate | thousandsSeparator }} {{ "kWh" | translate }}
                    } @else { - }
                  </td>
                  <td class="align-middle">
                    @if (consumption.consumption_corrected_official) {
                    {{ consumption.consumption_corrected_official | thousandsSeparator }} {{ "kWh" | translate }}
                    } @else { - }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </nb-accordion-item-body>
        </nb-accordion-item>
        }

        <!-- CONSUMPTIONS BY ENERGY TYPE -->
        @for (energyElt of energyTypeConsumptionsList; track energyElt;) {
        <nb-accordion-item expanded>
          <nb-accordion-item-header (click)="toggleAccordion()">
            <span class="text">
              {{ energyElt[0]?.energy_type?.name }}
            </span>
          </nb-accordion-item-header>
          <nb-accordion-item-body>
            <table class="table with-data">
              <thead>
                <tr>
                  <th class="w-20 align-middle">{{ "Building" | translate }}</th>
                  <th class="align-middle">{{ "Year" | translate }}</th>
                  <th class="align-middle">{{ "Raw consumption" | translate }}</th>
                  <th class="align-middle">{{ "Corrected uses and climate" | translate }}</th>
                  <th class="align-middle">{{ "Corrected official" | translate }}</th>
                  <th class="align-middle">{{ "Comment" | translate }}</th>
                  @if (!readOnly) {
                    <th class="align-middle"></th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (consumption of energyElt; track consumption.id) {
                <tr>
                  <!-- BUILDING NAME (PERIMETER) -->
                  <td class="align-middle">
                    {{ consumption.perimeter.name }}
                    @if (consumption.area) { ({{ consumption.area | thousandsSeparator }} {{ "m²" | translate }}) }
                  </td>
                  <!-- CONSUMPTION YEAR -->
                  <td class="align-middle">{{ consumption.year }}</td>
                  <!-- RAW CONSUMPTION IN KWH -->
                  <td class="align-middle">
                    @if (consumption.consumption) {
                    {{ consumption.consumption | thousandsSeparator }} {{ "kWh" | translate }}
                    } @else { - }
                  </td>
                  <!-- CONSUMPTION IN KWH (CORRECTED CLIMATE) -->
                  <td class="align-middle">
                    @if (consumption.consumption_corrected_climate) {
                    {{ consumption.consumption_corrected_climate | thousandsSeparator }} {{ "kWh" | translate }}
                    } @else { - }
                  </td>
                  <!-- CONSUMPTION IN KWH (CORRECTED OFFICIAL) -->
                  <td class="align-middle">
                    @if (consumption.consumption_corrected_official) {
                    {{ consumption.consumption_corrected_official | thousandsSeparator }} {{ "kWh" | translate }}
                    } @else { - }
                  </td>
                  <!-- CONSUMPTION COMMENT -->
                  <td class="align-middle">
                    {{ consumption.comment || "-" }}
                  </td>
                  @if (!readOnly) {
                    <td class="align-middle">
                      <div class="header-icons">
                        <button nbButton ghost class="btn btn-sm btn-outline-danger" (click)="editConsumption(consumption)" [disabled]="!canAddConsumption()">
                          <i class="fa-thin fa-pen-to-square"></i>
                        </button>
                        <button nbButton ghost class="btn btn-sm btn-outline-danger" (click)="deleteConsumption(consumption)" [disabled]="!canAddConsumption()">
                          <i class="fa-thin fa-trash-can"></i>
                        </button>
                      </div>
                    </td>
                  }
                </tr>
                }
              </tbody>
            </table>
            @if (isAccordionExpanded && !readOnly) {
            <div class="add-energy-container-unfolded">
              <a class="add-energy-button" (click)="openAddConsumptionDialog()" [class.disabled]="!canAddConsumption()">
                (+)
                <span>{{ "Add an energy" | translate }}</span>
              </a>
            </div>
            }
          </nb-accordion-item-body>
        </nb-accordion-item>
      }
      </nb-accordion>
    } @else {
      <!-- No data -->
      <nb-accordion multi class="custom-accordion mt-0" (toggle)="onAccordionToggle($event)">
        <nb-accordion-item expanded>
          <nb-accordion-item-header>
            <span class="text">
              {{ 'Electricity' | translate }}
            </span>
          </nb-accordion-item-header>
          <nb-accordion-item-body>
            <table class="table">
              <thead>
                <tr>
                  <th class="w-20 align-middle">{{ "Building" | translate }}</th>
                  <th class="align-middle">{{ "Year" | translate }}</th>
                  <th class="align-middle">{{ "Raw consumption" | translate }}</th>
                  <th class="align-middle">{{ "Corrected uses and climate" | translate }}</th>
                  <th class="align-middle">{{ "Corrected official" | translate }}</th>
                  <th class="align-middle">{{ "Comment" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="align-middle">
                  </td>
                  <td class="align-middle">
                  </td>
                  <td class="align-middle">
                  </td>
                  <td class="align-middle">
                  </td>
                  <td class="align-middle">
                  </td>
                  <td class="align-middle">
                  </td>
                </tr>
              </tbody>
            </table>
          </nb-accordion-item-body>
        </nb-accordion-item>
      </nb-accordion>
    }
  </ng-container>
}

@if (!energyTypeConsumptionsList?.length && !readOnly) {
  <a class="add-energy-button" (click)="openAddConsumptionDialog()" [class.disabled]="!canAddConsumption()">
    (+) <span>{{ "Add an energy" | translate }}</span>
  </a>
}
<div class="correction-text-container">
  <div class="correction-text">
    *{{ "Corrected for seasonal variations & uses" | translate }}
    </div>
</div>

